import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

interface QuestionsSidebarHeaderProps extends ComponentProps<'div'> {
  number?: number;
}

export default function QuestionsSidebarHeader(questionsSidebarHeaderProps: QuestionsSidebarHeaderProps) {
  const { number, children, className, ...props } = questionsSidebarHeaderProps;
  return (
    <div className={cn('flex items-center justify-between', className)} {...props}>
      <h5 className={'text-muted-foreground text-xs tracking-tight whitespace-nowrap uppercase'}>Pytania ( {number} )</h5>
      {children}
    </div>
  );
}
